export default __webpack_public_path__ + "static/media/choosing_the_parameters_1.30d07d07.png";